/* eslint-disable */
var _a;
import { __assign, __spreadArrays } from "tslib";
import initial from 'lodash/initial';
import includes from 'lodash/includes';
import intersection from 'lodash/intersection';
import isEmpty from 'lodash/isEmpty';
import last from 'lodash/last';
import negate from 'lodash/negate';
import sortBy from 'lodash/sortBy';
var HEADER_BLOCK = {
    ONE: 'header-one',
    TWO: 'header-two',
    THREE: 'header-three',
};
var INLINE_HEADER = {
    ONE: 'inline-header-one',
    TWO: 'inline-header-two',
    THREE: 'inline-header-three',
};
var INLINE_HEADERS = [
    INLINE_HEADER.THREE,
    INLINE_HEADER.TWO,
    INLINE_HEADER.ONE,
];
var INLINE_HEADER_TO_BLOCK = (_a = {},
    _a[INLINE_HEADER.ONE] = HEADER_BLOCK.ONE,
    _a[INLINE_HEADER.TWO] = HEADER_BLOCK.TWO,
    _a[INLINE_HEADER.THREE] = HEADER_BLOCK.THREE,
    _a);
/**
 * Removes inline headers from a given block.
 *
 * If 'unstyled' block contains only inline headers and spaces (no plain text),
 * it's type is changed to the smallest header block. E.g.: Block with inline-header-one
 * & inline-header-two will be converted to header-two block.
 */
export var removeInlineHeaderRanges = function (block) {
    var inlineHeaderRanges = getInlineHeaderRanges(block.inlineStyleRanges || []);
    if (isEmpty(inlineHeaderRanges)) {
        return block;
    }
    return __assign(__assign({}, block), { type: getBlockType(block.type, block.text, inlineHeaderRanges), inlineStyleRanges: omitInlineHeaderRanges(block.inlineStyleRanges || []) });
};
var isInlineHeaderRange = function (range) { return includes(INLINE_HEADERS, range.style); };
var omitInlineHeaderRanges = function (ranges) {
    return ranges.filter(negate(isInlineHeaderRange));
};
var getInlineHeaderRanges = function (ranges) { return ranges.filter(isInlineHeaderRange); };
var getBlockType = function (type, text, inlineHeaderRanges) {
    return type === 'unstyled' && shouldConvertToHeaderBlock(text, inlineHeaderRanges)
        ? getBlockHeaderType(inlineHeaderRanges)
        : type;
};
var shouldConvertToHeaderBlock = function (text, inlineStyleRanges) {
    return sortBy(inlineStyleRanges, 'offset')
        .map(function (range) { return [range.offset, range.offset + range.length]; })
        .reduce(function (ranges, range) {
        var lastRange = last(ranges);
        return lastRange && isOverlapping(lastRange, range)
            ? __spreadArrays(initial(ranges), [mergeOverlappingRanges(lastRange, range)]) : __spreadArrays(ranges, [range]);
    }, [])
        .reverse()
        .reduce(function (text, range) { return "" + text.slice(0, range[0]) + text.slice(range[1]); }, text)
        .replace(/\s/g, '').length === 0;
};
var isInRange = function (number, range) { return range[0] <= number && number <= range[1]; };
var isOverlapping = function (rangeA, rangeB) {
    return rangeA &&
        rangeB &&
        (isInRange(rangeB[0], rangeA) || isInRange(rangeB[1], rangeA));
};
var mergeOverlappingRanges = function (rangeA, rangeB) { return [
    Math.min(rangeA[0], rangeB[0]),
    Math.max(rangeA[1], rangeB[1]),
]; };
var getBlockHeaderType = function (inlineHeaderRanges) {
    var smallestInlineHeader = intersection(INLINE_HEADERS, inlineHeaderRanges.map(function (range) { return range.style; }))[0];
    return INLINE_HEADER_TO_BLOCK[smallestInlineHeader];
};
//# sourceMappingURL=removeInlineHeaderRanges.js.map